import React from 'react';
import { SectionHeading } from './SectionHeading';
const steps = [{
  n: '1',
  title: 'Choose and print',
  body: 'Open anything on a phone, a tablet or a laptop and send it to the printer. Plain paper is fine for all of it.'
}, {
  n: '2',
  title: 'Raid the recycling',
  body: 'Cardboard, bottle caps, straws, string, tape. Nothing here needs a trip to a craft shop.'
}, {
  n: '3',
  title: 'Build it and break it',
  body: 'The first attempt usually fails. That page is in every project, and it is the part your child learns from.'
}];
export function ThreeSteps() {
  return <section aria-labelledby="how-heading" id="how" className="scroll-mt-24" data-id="element-200" data-mp="iouv960rzgt">
      <SectionHeading index="06" title="How this works" data-id="element-201" data-mp="4i72x4cqsg28" />

      <div className="mt-8 grid gap-px bg-rule sm:grid-cols-3" data-id="element-202" data-mp="4ks8a3c91e4q">
        {steps.map(step => <div key={step.n} className="bg-surface p-6 sm:p-7" data-id="element-203" data-mp="1utaemr7wbdfh">
            <span aria-hidden="true" className="flex h-9 w-9 items-center justify-center rounded-full bg-gold font-display text-[16px] font-semibold text-ink" data-id="element-204" data-mp="1yvovj5s08344">
              {step.n}
            </span>
            <h3 className="mt-4 font-display text-[19px] font-semibold leading-tight text-ink" data-id="element-205" data-mp="8mgmy2l52ued">
              {step.title}
            </h3>
            <p className="mt-2 font-sans text-[14.5px] leading-relaxed text-ink/70" data-id="element-206" data-mp="idumgad3bu7i">{step.body}</p>
          </div>)}
      </div>
    </section>;
}